// src/components/Badge.tsx
import "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Badge = ({ tone = "default", className, children, ...props }) => {
  return /* @__PURE__ */ jsx("span", { className: clsx("zek-badge", tone === "strong" && "zek-badge-strong", className), ...props, children });
};

// src/components/BackButton.tsx
import "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var BackButton = ({
  href,
  id,
  ariaLabel = "Back",
  className
}) => {
  const classes = ["zek-back-button", className].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx2("a", { id, className: classes, href, "aria-label": ariaLabel, children: /* @__PURE__ */ jsx2(
    "svg",
    {
      viewBox: "0 0 24 24",
      className: "zek-back-button__icon",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      children: /* @__PURE__ */ jsx2("path", { d: "M15 18l-6-6 6-6", strokeLinecap: "round", strokeLinejoin: "round" })
    }
  ) });
};

// src/components/Button.tsx
import "react";
import clsx2 from "clsx";
import { jsx as jsx3 } from "react/jsx-runtime";
var Button = ({
  variant = "primary",
  size = "default",
  className,
  children,
  as = "button",
  ...props
}) => {
  const classes = clsx2(
    "zek-button",
    variant === "primary" ? "zek-button-primary" : "zek-button-secondary",
    size === "compact" && "zek-button-compact",
    className
  );
  if (as === "a") {
    return /* @__PURE__ */ jsx3("a", { className: classes, ...props, children });
  }
  return /* @__PURE__ */ jsx3("button", { className: classes, ...props, children });
};

// src/components/Card.tsx
import "react";
import clsx3 from "clsx";
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
var Card = ({ title, description, children, className, ...props }) => {
  return /* @__PURE__ */ jsxs("div", { className: clsx3("zek-card", className), ...props, children: [
    title && /* @__PURE__ */ jsx4("div", { className: "zek-card-title", children: title }),
    description && /* @__PURE__ */ jsx4("p", { className: "zek-card-subtitle", children: description }),
    children
  ] });
};

// src/components/Checkbox.tsx
import "react";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var Checkbox = ({ label, ...props }) => {
  return /* @__PURE__ */ jsxs2("label", { className: "zek-checkbox", children: [
    /* @__PURE__ */ jsx5("input", { type: "checkbox", className: "zek-checkbox-input", ...props }),
    label && /* @__PURE__ */ jsx5("span", { className: "zek-checkbox-label", children: label })
  ] });
};

// src/components/ColorPicker.tsx
import { useRef, useState, useEffect } from "react";
import clsx4 from "clsx";
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var DEFAULT_PRESET_COLORS = [
  "#000000",
  "#FFFFFF",
  "#FF0000",
  "#00FF00",
  "#0000FF",
  "#FFFF00",
  "#FF00FF",
  "#00FFFF",
  "#808080",
  "#FFA500"
];
var isValidColor = (color) => {
  if (/^#([0-9A-Fa-f]{3}){1,2}$/.test(color)) {
    return true;
  }
  const s = new Option().style;
  s.color = color;
  return s.color !== "";
};
var ColorPicker = ({
  label,
  value,
  onChange,
  presetColors = DEFAULT_PRESET_COLORS,
  className
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  const handleColorChange = (newColor) => {
    if (isValidColor(newColor)) {
      onChange(newColor);
    }
  };
  const safeColor = isValidColor(value) ? value : "#000000";
  return /* @__PURE__ */ jsxs3("div", { className: clsx4("zek-field", className), ref: containerRef, children: [
    label && /* @__PURE__ */ jsx6("label", { className: "zek-label", children: label }),
    /* @__PURE__ */ jsxs3("div", { className: "zek-color-picker", children: [
      /* @__PURE__ */ jsx6(
        "button",
        {
          type: "button",
          className: "zek-color-picker-trigger",
          onClick: () => setIsOpen(!isOpen),
          style: { backgroundColor: safeColor },
          "aria-label": `Select color, current: ${value}`,
          children: /* @__PURE__ */ jsx6("span", { className: "zek-color-picker-value", children: value })
        }
      ),
      isOpen && /* @__PURE__ */ jsxs3("div", { className: "zek-color-picker-popup", children: [
        /* @__PURE__ */ jsx6("div", { className: "zek-color-picker-presets", children: presetColors.map((color) => /* @__PURE__ */ jsx6(
          "button",
          {
            type: "button",
            className: clsx4("zek-color-picker-preset", {
              "zek-color-picker-preset-active": color.toLowerCase() === value.toLowerCase()
            }),
            style: { backgroundColor: color },
            onClick: () => {
              handleColorChange(color);
              setIsOpen(false);
            },
            "aria-label": `Select color ${color}`
          },
          color
        )) }),
        /* @__PURE__ */ jsxs3("div", { className: "zek-color-picker-custom", children: [
          /* @__PURE__ */ jsx6(
            "input",
            {
              type: "color",
              value: safeColor,
              onChange: (e) => handleColorChange(e.target.value),
              className: "zek-color-picker-input"
            }
          ),
          /* @__PURE__ */ jsx6(
            "input",
            {
              type: "text",
              value,
              onChange: (e) => handleColorChange(e.target.value),
              className: "zek-input",
              placeholder: "#000000"
            }
          )
        ] })
      ] })
    ] })
  ] });
};

// src/components/Dropdown.tsx
import React7 from "react";
import { createPortal } from "react-dom";
import clsx5 from "clsx";
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var findNextEnabledIndex = (options, startIndex, direction) => {
  if (options.length === 0) return -1;
  for (let step = 0; step < options.length; step += 1) {
    const index = (startIndex + step * direction + options.length) % options.length;
    if (!options[index].disabled) return index;
  }
  return -1;
};
var getNextIndex = (options, currentIndex, direction) => {
  if (options.length === 0) return -1;
  const startIndex = currentIndex < 0 ? direction === 1 ? 0 : options.length - 1 : currentIndex + direction;
  return findNextEnabledIndex(options, startIndex, direction);
};
var Dropdown = (props) => {
  const {
    label,
    helperText,
    placeholder = "Select an option",
    options,
    value,
    defaultValue,
    multiple = false,
    disabled,
    className,
    name,
    id,
    required,
    menuMaxHeight = 320,
    "aria-invalid": ariaInvalid,
    "aria-describedby": describedBy
  } = props;
  const isControlled = value !== void 0;
  const [internalValue, setInternalValue] = React7.useState(defaultValue ?? (multiple ? [] : ""));
  const [isOpen, setIsOpen] = React7.useState(false);
  const [highlightedIndex, setHighlightedIndex] = React7.useState(-1);
  const [menuPosition, setMenuPosition] = React7.useState({
    top: 0,
    left: 0,
    width: 0,
    maxHeight: menuMaxHeight,
    openUp: false
  });
  const buttonRef = React7.useRef(null);
  const menuRef = React7.useRef(null);
  const generatedId = React7.useId();
  const buttonId = id ?? generatedId;
  const listboxId = `${buttonId}-listbox`;
  const helperId = helperText ? `${buttonId}-help` : void 0;
  const currentValue = isControlled ? value : internalValue;
  const selectedValues = Array.isArray(currentValue) ? currentValue : [currentValue];
  const selectedOptions = options.filter((option) => selectedValues.includes(option.value));
  const selectedLabel = selectedOptions.map((option) => option.label).join(", ");
  const updatePosition = React7.useCallback(() => {
    if (typeof window === "undefined") return;
    if (!buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const viewportPadding = 12;
    const spaceBelow = window.innerHeight - rect.bottom - viewportPadding;
    const spaceAbove = rect.top - viewportPadding;
    const shouldOpenUp = spaceBelow < Math.min(220, menuMaxHeight) && spaceAbove > spaceBelow;
    const availableSpace = shouldOpenUp ? spaceAbove : spaceBelow;
    const width = Math.min(multiple ? Math.max(rect.width, 240) : rect.width, window.innerWidth - viewportPadding * 2);
    const left = Math.min(
      Math.max(viewportPadding, rect.left),
      Math.max(viewportPadding, window.innerWidth - width - viewportPadding)
    );
    setMenuPosition({
      top: shouldOpenUp ? rect.top - 8 : rect.bottom + 8,
      left,
      width,
      maxHeight: Math.max(80, Math.min(menuMaxHeight, availableSpace)),
      openUp: shouldOpenUp
    });
  }, [menuMaxHeight, multiple]);
  const closeMenu = React7.useCallback(() => {
    setIsOpen(false);
  }, []);
  const openMenu = () => {
    if (disabled) return;
    const selectedIndex = options.findIndex((option) => selectedValues.includes(option.value) && !option.disabled);
    setHighlightedIndex(selectedIndex >= 0 ? selectedIndex : findNextEnabledIndex(options, 0, 1));
    setIsOpen(true);
  };
  const handleSelect = React7.useCallback(
    (nextValue) => {
      if (props.multiple) {
        const values = Array.isArray(currentValue) ? currentValue : [];
        const next = values.includes(nextValue) ? values.filter((entry) => entry !== nextValue) : [...values, nextValue];
        if (!isControlled) setInternalValue(next);
        props.onChange?.(next);
        menuRef.current?.focus();
      } else {
        const next = !props.required && currentValue === nextValue ? "" : nextValue;
        if (!isControlled) setInternalValue(next);
        props.onChange?.(next);
        closeMenu();
        buttonRef.current?.focus();
      }
    },
    [closeMenu, currentValue, isControlled, props]
  );
  React7.useEffect(() => {
    if (disabled) closeMenu();
  }, [disabled, closeMenu]);
  React7.useEffect(() => {
    if (!isOpen || typeof window === "undefined") return;
    const frame = window.requestAnimationFrame(() => {
      updatePosition();
      menuRef.current?.focus();
    });
    const handleReflow = () => {
      window.requestAnimationFrame(updatePosition);
    };
    window.addEventListener("resize", handleReflow);
    window.addEventListener("scroll", handleReflow, true);
    let resizeObserver = null;
    if (window.ResizeObserver && buttonRef.current) {
      resizeObserver = new ResizeObserver(handleReflow);
      resizeObserver.observe(buttonRef.current);
    }
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("resize", handleReflow);
      window.removeEventListener("scroll", handleReflow, true);
      resizeObserver?.disconnect();
    };
  }, [isOpen, updatePosition]);
  React7.useEffect(() => {
    if (!isOpen) return;
    const handlePointerDown = (event) => {
      const target = event.composedPath()[0];
      if (buttonRef.current?.contains(target) || menuRef.current?.contains(target)) {
        return;
      }
      closeMenu();
    };
    document.addEventListener("pointerdown", handlePointerDown);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [isOpen, closeMenu]);
  React7.useEffect(() => {
    if (highlightedIndex < 0 || !isOpen) return;
    const optionElement = menuRef.current?.querySelector(`[data-option-index="${highlightedIndex}"]`);
    optionElement?.scrollIntoView?.({ block: "nearest" });
  }, [highlightedIndex, isOpen, listboxId]);
  const handleButtonKeyDown = (event) => {
    if (disabled) return;
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      if (!isOpen) {
        openMenu();
        if (event.key === "ArrowUp" && !selectedOptions.length) {
          setHighlightedIndex(findNextEnabledIndex(options, options.length - 1, -1));
        }
      } else {
        setHighlightedIndex((prev) => getNextIndex(options, prev, event.key === "ArrowDown" ? 1 : -1));
      }
    }
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      if (!isOpen) {
        openMenu();
      } else if (highlightedIndex >= 0) {
        const option = options[highlightedIndex];
        if (option && !option.disabled) handleSelect(option.value);
      }
    }
  };
  const handleMenuKeyDown = (event) => {
    if (event.key === "Tab") {
      closeMenu();
      buttonRef.current?.focus();
      return;
    }
    if (event.key === "Escape") {
      event.preventDefault();
      closeMenu();
      buttonRef.current?.focus();
      return;
    }
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      setHighlightedIndex((prev) => getNextIndex(options, prev, event.key === "ArrowDown" ? 1 : -1));
      return;
    }
    if (event.key === "Home") {
      event.preventDefault();
      setHighlightedIndex(findNextEnabledIndex(options, 0, 1));
      return;
    }
    if (event.key === "End") {
      event.preventDefault();
      setHighlightedIndex(findNextEnabledIndex(options, options.length - 1, -1));
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      const option = options[highlightedIndex];
      if (option && !option.disabled) handleSelect(option.value);
    }
  };
  const handleMenuBlur = (event) => {
    const nextTarget = event.relatedTarget;
    if (nextTarget && (menuRef.current?.contains(nextTarget) || buttonRef.current?.contains(nextTarget))) {
      return;
    }
    closeMenu();
  };
  return /* @__PURE__ */ jsxs4("div", { className: clsx5("zek-field", "zek-dropdown", className), children: [
    label && /* @__PURE__ */ jsx7("label", { className: "zek-label", htmlFor: buttonId, children: label }),
    /* @__PURE__ */ jsxs4(
      "button",
      {
        ref: buttonRef,
        id: buttonId,
        type: "button",
        className: clsx5("zek-dropdown__button", isOpen && "zek-dropdown__button--open"),
        onClick: () => isOpen ? closeMenu() : openMenu(),
        onKeyDown: handleButtonKeyDown,
        "aria-haspopup": "listbox",
        "aria-expanded": isOpen,
        "aria-controls": listboxId,
        "aria-describedby": [helperId, describedBy].filter(Boolean).join(" ") || void 0,
        "aria-invalid": ariaInvalid,
        "aria-required": required,
        disabled,
        children: [
          /* @__PURE__ */ jsx7("span", { className: clsx5("zek-dropdown__value", !selectedOptions.length && "zek-dropdown__placeholder"), children: selectedLabel || placeholder }),
          /* @__PURE__ */ jsx7("span", { className: "zek-dropdown__icon", "aria-hidden": "true", children: /* @__PURE__ */ jsx7("svg", { viewBox: "0 0 20 20", fill: "none", role: "presentation", children: /* @__PURE__ */ jsx7(
            "path",
            {
              d: "M5 7.5L10 12.5L15 7.5",
              stroke: "currentColor",
              strokeWidth: "1.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ) }) })
        ]
      }
    ),
    helperText && /* @__PURE__ */ jsx7("p", { className: "zek-helper-text", id: helperId, children: helperText }),
    name && /* @__PURE__ */ jsx7("input", { type: "hidden", name, value: multiple ? JSON.stringify(currentValue) : currentValue }),
    isOpen && createPortal(
      /* @__PURE__ */ jsxs4(
        "div",
        {
          ref: menuRef,
          id: listboxId,
          role: "listbox",
          "aria-label": label || placeholder,
          "aria-multiselectable": multiple || void 0,
          tabIndex: -1,
          "aria-activedescendant": highlightedIndex >= 0 ? `${listboxId}-option-${highlightedIndex}` : void 0,
          className: clsx5(
            "zek-dropdown__menu",
            menuPosition.openUp ? "zek-dropdown__menu--above" : "zek-dropdown__menu--below"
          ),
          style: {
            top: `${menuPosition.top}px`,
            left: `${menuPosition.left}px`,
            width: `${menuPosition.width}px`,
            maxHeight: `${menuPosition.maxHeight}px`
          },
          onKeyDown: handleMenuKeyDown,
          onBlur: handleMenuBlur,
          children: [
            options.length === 0 && /* @__PURE__ */ jsx7("div", { className: "zek-dropdown__empty", role: "presentation", children: "No options available" }),
            options.map((option, index) => {
              const isSelected = selectedValues.includes(option.value);
              const isHighlighted = index === highlightedIndex;
              return /* @__PURE__ */ jsxs4(
                "button",
                {
                  id: `${listboxId}-option-${index}`,
                  "data-option-index": index,
                  tabIndex: -1,
                  onMouseDown: (event) => event.preventDefault(),
                  type: "button",
                  role: "option",
                  "aria-selected": isSelected,
                  className: clsx5(
                    "zek-dropdown__option",
                    isSelected && "zek-dropdown__option--selected",
                    isHighlighted && "zek-dropdown__option--active",
                    option.disabled && "zek-dropdown__option--disabled"
                  ),
                  onMouseEnter: () => {
                    if (!option.disabled) setHighlightedIndex(index);
                  },
                  onClick: () => {
                    if (!option.disabled) handleSelect(option.value);
                  },
                  disabled: option.disabled,
                  children: [
                    /* @__PURE__ */ jsxs4("span", { className: "zek-dropdown__option-text", children: [
                      /* @__PURE__ */ jsx7("span", { className: "zek-dropdown__option-label", children: option.label }),
                      option.description && /* @__PURE__ */ jsx7("span", { className: "zek-dropdown__option-description", children: option.description })
                    ] }),
                    /* @__PURE__ */ jsx7("span", { className: clsx5("zek-dropdown__option-check", multiple ? "zek-dropdown__option-checkbox" : "zek-dropdown__option-radio", multiple && isSelected && "zek-dropdown__option-checkbox--checked", !multiple && isSelected && "zek-dropdown__option-radio--checked"), "aria-hidden": "true", children: multiple && isSelected && /* @__PURE__ */ jsx7("svg", { viewBox: "0 0 20 20", fill: "none", role: "presentation", children: /* @__PURE__ */ jsx7(
                      "path",
                      {
                        d: "M5 10.5L8.5 14L15 7",
                        stroke: "currentColor",
                        strokeWidth: "1.6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                      }
                    ) }) })
                  ]
                },
                option.value
              );
            })
          ]
        }
      ),
      buttonRef.current?.getRootNode() instanceof window.ShadowRoot ? buttonRef.current.getRootNode() : document.body
    )
  ] });
};

// src/components/FileUpload.tsx
import { useRef as useRef2 } from "react";
import clsx6 from "clsx";
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var FileUpload = ({
  label,
  helperText,
  onChange,
  accept,
  value,
  placeholder = "Choose a file...",
  className
}) => {
  const inputRef = useRef2(null);
  const handleChange = (e) => {
    const file = e.target.files?.[0] || null;
    onChange(file);
  };
  const handleClick = () => {
    inputRef.current?.click();
  };
  return /* @__PURE__ */ jsxs5("div", { className: clsx6("zek-field", className), children: [
    label && /* @__PURE__ */ jsx8("label", { className: "zek-label", children: label }),
    /* @__PURE__ */ jsxs5("div", { className: "zek-file-upload", children: [
      /* @__PURE__ */ jsx8(
        "button",
        {
          type: "button",
          className: "zek-file-upload-button",
          onClick: handleClick,
          children: value ? value.name : placeholder
        }
      ),
      /* @__PURE__ */ jsx8(
        "input",
        {
          ref: inputRef,
          type: "file",
          accept,
          onChange: handleChange,
          className: "zek-file-upload-input",
          "aria-label": label || "Upload file"
        }
      )
    ] }),
    helperText && /* @__PURE__ */ jsx8("p", { className: "zek-helper-text", children: helperText })
  ] });
};

// src/components/Footer.tsx
import "react";
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var Footer = ({
  copyright,
  links = []
}) => {
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const defaultCopyright = `Copyright \xA9 ${currentYear} ZekTec`;
  return /* @__PURE__ */ jsxs6("footer", { className: "zek-footer", children: [
    /* @__PURE__ */ jsx9("a", { href: "mailto:hi@zektec.com", children: copyright || defaultCopyright }),
    links.map((link, index) => link.href ? /* @__PURE__ */ jsx9(
      "a",
      {
        href: link.href,
        children: link.label
      },
      index
    ) : /* @__PURE__ */ jsx9(
      "button",
      {
        type: "button",
        onClick: link.onClick,
        children: link.label
      },
      index
    ))
  ] });
};

// src/components/Header.tsx
import "react";

// src/components/Icon.tsx
import "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var Icon = ({
  color = "var(--zek-color-primary)",
  className = "",
  height = "2rem"
}) => {
  return /* @__PURE__ */ jsx10(
    "svg",
    {
      className,
      height,
      viewBox: "0 0 73 115",
      style: { fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: 2 },
      children: /* @__PURE__ */ jsx10(
        "path",
        {
          d: "M72.866,57.311l-42.102,-57.311l-30.764,0l42.467,57.311l-42.467,57.312l30.764,-0l42.102,-57.312Z",
          style: { fill: color }
        }
      )
    }
  );
};

// src/components/Header.tsx
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var Header = ({
  navigation = [],
  homeUrl = "/"
}) => {
  return /* @__PURE__ */ jsx11("header", { className: "zek-header zek-header-sticky", children: /* @__PURE__ */ jsxs7("div", { className: "zek-header-inner", children: [
    /* @__PURE__ */ jsxs7("a", { href: homeUrl, className: "zek-brand", children: [
      /* @__PURE__ */ jsx11(Icon, { height: "1.2rem" }),
      /* @__PURE__ */ jsx11("h2", { className: "zek-brand-title", children: "ZekTec" })
    ] }),
    navigation && navigation.length > 0 && /* @__PURE__ */ jsx11("nav", { className: "zek-nav", "aria-label": "Primary navigation", children: navigation.map((item) => /* @__PURE__ */ jsx11(
      Button,
      {
        as: "a",
        href: item.href,
        variant: "secondary",
        className: "zek-button-compact",
        children: item.label
      },
      item.href
    )) })
  ] }) });
};

// src/components/IconButton.tsx
import "react";
import clsx7 from "clsx";
import { jsx as jsx12 } from "react/jsx-runtime";
var IconButton = ({
  icon,
  variant = "default",
  size = "md",
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx12(
    "button",
    {
      className: clsx7(
        "zek-icon-button",
        `zek-icon-button-${variant}`,
        `zek-icon-button-${size}`,
        className
      ),
      ...props,
      children: icon
    }
  );
};

// src/components/LandingNavBar.tsx
import "react";
import { Fragment, jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
var LandingNavBar = ({
  tabs = [],
  brandName = "ZekTec",
  homeUrl = "/",
  menuLabel = "Menu"
}) => {
  const hasTabs = tabs.length > 0;
  return /* @__PURE__ */ jsx13("header", { className: "zek-landing-nav", children: /* @__PURE__ */ jsxs8("div", { className: "zek-landing-nav__inner", children: [
    /* @__PURE__ */ jsxs8("a", { className: "zek-landing-nav__logo", href: homeUrl, children: [
      /* @__PURE__ */ jsx13(Icon, { height: "1.2rem" }),
      /* @__PURE__ */ jsx13("span", { className: "zek-landing-nav__logo-text", children: brandName })
    ] }),
    hasTabs && /* @__PURE__ */ jsxs8(Fragment, { children: [
      /* @__PURE__ */ jsx13("nav", { className: "zek-landing-nav__links", "aria-label": "Primary navigation", children: tabs.map((tab) => /* @__PURE__ */ jsx13("a", { className: "zek-landing-nav__link link", href: tab.href, children: /* @__PURE__ */ jsx13("span", { children: tab.label }) }, tab.href)) }),
      /* @__PURE__ */ jsxs8("details", { className: "zek-landing-nav__menu", children: [
        /* @__PURE__ */ jsx13("summary", { className: "zek-landing-nav__menu-toggle link", children: menuLabel }),
        /* @__PURE__ */ jsx13("div", { className: "zek-landing-nav__menu-panel", children: tabs.map((tab) => /* @__PURE__ */ jsx13("a", { className: "zek-landing-nav__menu-item link", href: tab.href, children: /* @__PURE__ */ jsx13("span", { children: tab.label }) }, tab.href)) })
      ] })
    ] })
  ] }) });
};

// src/components/MarkdownPreview.tsx
import "react";
import ReactMarkdown from "react-markdown";
import { jsx as jsx14 } from "react/jsx-runtime";
var MarkdownPreview = ({ markdown }) => {
  return /* @__PURE__ */ jsx14("div", { className: "zek-card", children: /* @__PURE__ */ jsx14(ReactMarkdown, { className: "zek-markdown", children: markdown }) });
};

// src/components/Menu.tsx
import React15 from "react";
import { createPortal as createPortal2 } from "react-dom";
import clsx8 from "clsx";
import { jsx as jsx15 } from "react/jsx-runtime";
var MenuContext = React15.createContext(null);
var useMenuContext = () => {
  const context = React15.useContext(MenuContext);
  if (!context) {
    throw new Error("Menu components must be used within <Menu>.");
  }
  return context;
};
var Menu = ({
  children,
  defaultOpen = false,
  open,
  onOpenChange,
  disabled = false
}) => {
  const isControlled = open !== void 0;
  const [uncontrolledOpen, setUncontrolledOpen] = React15.useState(defaultOpen);
  const isOpen = isControlled ? Boolean(open) : uncontrolledOpen;
  const buttonRef = React15.useRef(null);
  const menuRef = React15.useRef(null);
  const buttonId = React15.useId();
  const menuId = `${buttonId}-menu`;
  const setOpen = React15.useCallback(
    (nextOpen) => {
      if (!isControlled) {
        setUncontrolledOpen(nextOpen);
      }
      onOpenChange?.(nextOpen);
    },
    [isControlled, onOpenChange]
  );
  const toggle = React15.useCallback(() => {
    if (disabled) return;
    setOpen(!isOpen);
  }, [disabled, isOpen, setOpen]);
  React15.useEffect(() => {
    if (!isOpen) return;
    const handlePointerDown = (event) => {
      const target = event.target;
      if (buttonRef.current?.contains(target) || menuRef.current?.contains(target)) {
        return;
      }
      setOpen(false);
    };
    document.addEventListener("pointerdown", handlePointerDown);
    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, [isOpen, setOpen]);
  return /* @__PURE__ */ jsx15(
    MenuContext.Provider,
    {
      value: {
        isOpen,
        setOpen,
        toggle,
        disabled,
        buttonRef,
        menuRef,
        buttonId,
        menuId
      },
      children
    }
  );
};
var MenuButton = React15.forwardRef(
  ({ onClick, onKeyDown, disabled: disabledProp, className, ...props }, forwardedRef) => {
    const { isOpen, toggle, disabled, buttonRef, buttonId, menuId } = useMenuContext();
    const setRefs = React15.useCallback(
      (node) => {
        buttonRef.current = node;
        if (typeof forwardedRef === "function") {
          forwardedRef(node);
        } else if (forwardedRef) {
          forwardedRef.current = node;
        }
      },
      [buttonRef, forwardedRef]
    );
    return /* @__PURE__ */ jsx15(
      "button",
      {
        ...props,
        ref: setRefs,
        id: buttonId,
        type: props.type ?? "button",
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": menuId,
        disabled: disabled || disabledProp,
        className: clsx8(className, isOpen && "zek-dropdown__button--open"),
        onClick: (event) => {
          onClick?.(event);
          if (event.defaultPrevented) return;
          toggle();
        },
        onKeyDown: (event) => {
          onKeyDown?.(event);
          if (event.defaultPrevented) return;
          if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            toggle();
          }
        }
      }
    );
  }
);
MenuButton.displayName = "MenuButton";
var MenuItems = ({
  align = "start",
  side = "bottom",
  sideOffset = 8,
  matchWidth = false,
  maxHeight = 320,
  className,
  style,
  onKeyDown,
  ...props
}) => {
  const { isOpen, setOpen, buttonRef, menuRef, menuId, buttonId } = useMenuContext();
  const [position, setPosition] = React15.useState({
    top: 0,
    left: 0,
    width: 0,
    maxHeight
  });
  const updatePosition = React15.useCallback(() => {
    if (typeof window === "undefined") return;
    if (!buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const viewportPadding = 12;
    const spaceBelow = window.innerHeight - rect.bottom - viewportPadding;
    const spaceAbove = rect.top - viewportPadding;
    const shouldOpenUp = side === "top" || spaceBelow < Math.min(220, maxHeight) && spaceAbove > spaceBelow;
    const availableSpace = shouldOpenUp ? spaceAbove : spaceBelow;
    const explicitWidth = typeof style?.width === "number" ? style.width : typeof style?.width === "string" && style.width.endsWith("px") ? Number.parseFloat(style.width) : void 0;
    const width = matchWidth ? rect.width : explicitWidth ?? Math.min(280, window.innerWidth - viewportPadding * 2);
    let left = rect.left;
    if (align === "end") {
      left = rect.right - width;
    } else if (align === "center") {
      left = rect.left + rect.width / 2 - width / 2;
    }
    left = Math.min(
      Math.max(viewportPadding, left),
      Math.max(viewportPadding, window.innerWidth - width - viewportPadding)
    );
    setPosition({
      top: shouldOpenUp ? rect.top - sideOffset : rect.bottom + sideOffset,
      left,
      width,
      maxHeight: Math.max(80, Math.min(maxHeight, availableSpace))
    });
  }, [align, buttonRef, matchWidth, maxHeight, side, sideOffset, style?.width]);
  React15.useEffect(() => {
    if (!isOpen) return;
    const frame = window.requestAnimationFrame(() => {
      updatePosition();
      menuRef.current?.focus();
    });
    const handleReflow = () => window.requestAnimationFrame(updatePosition);
    window.addEventListener("resize", handleReflow);
    window.addEventListener("scroll", handleReflow, true);
    let resizeObserver = null;
    if (window.ResizeObserver && buttonRef.current) {
      resizeObserver = new ResizeObserver(handleReflow);
      resizeObserver.observe(buttonRef.current);
    }
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("resize", handleReflow);
      window.removeEventListener("scroll", handleReflow, true);
      resizeObserver?.disconnect();
    };
  }, [buttonRef, isOpen, menuRef, updatePosition]);
  if (!isOpen) return null;
  const handleKeyDown = (event) => {
    onKeyDown?.(event);
    if (event.defaultPrevented) return;
    if (event.key === "Escape") {
      event.preventDefault();
      setOpen(false);
      buttonRef.current?.focus();
      return;
    }
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
      const items = Array.from(
        menuRef.current?.querySelectorAll("[data-menu-item]:not([disabled])") ?? []
      );
      if (!items.length) return;
      const currentIndex = items.findIndex((item) => item === document.activeElement);
      const nextIndex = event.key === "ArrowDown" ? (currentIndex + 1) % items.length : (currentIndex - 1 + items.length) % items.length;
      items[nextIndex]?.focus();
    }
  };
  return createPortal2(
    /* @__PURE__ */ jsx15(
      "div",
      {
        ...props,
        ref: menuRef,
        id: menuId,
        role: "menu",
        tabIndex: -1,
        "aria-labelledby": buttonId,
        className: clsx8("zek-menu", className),
        style: {
          top: `${position.top}px`,
          left: `${position.left}px`,
          width: matchWidth ? `${position.width}px` : void 0,
          maxHeight: `${position.maxHeight}px`,
          ...style
        },
        onKeyDown: handleKeyDown
      }
    ),
    document.body
  );
};
var MenuItem = React15.forwardRef(
  ({ onClick, closeOnSelect = true, className, disabled, ...props }, forwardedRef) => {
    const { setOpen } = useMenuContext();
    return /* @__PURE__ */ jsx15(
      "button",
      {
        ...props,
        ref: forwardedRef,
        type: props.type ?? "button",
        role: "menuitem",
        "data-menu-item": true,
        className: clsx8("zek-menu__item", className),
        disabled,
        onClick: (event) => {
          onClick?.(event);
          if (event.defaultPrevented || disabled) return;
          if (closeOnSelect) setOpen(false);
        }
      }
    );
  }
);
MenuItem.displayName = "MenuItem";

// src/components/Modal.tsx
import React16 from "react";
import { createPortal as createPortal3 } from "react-dom";
import clsx9 from "clsx";
import { Fragment as Fragment2, jsx as jsx16, jsxs as jsxs9 } from "react/jsx-runtime";
var Modal = ({
  title,
  description,
  children,
  isOpen,
  defaultOpen = false,
  onOpenChange,
  trigger,
  size = "md",
  closeLabel = "Close",
  className
}) => {
  const isControlled = isOpen !== void 0;
  const [uncontrolledOpen, setUncontrolledOpen] = React16.useState(defaultOpen);
  const open = isControlled ? Boolean(isOpen) : uncontrolledOpen;
  const dialogRef = React16.useRef(null);
  const lastActiveRef = React16.useRef(null);
  const titleId = React16.useId();
  const descriptionId = React16.useId();
  const setOpen = React16.useCallback(
    (nextOpen) => {
      if (!isControlled) {
        setUncontrolledOpen(nextOpen);
      }
      onOpenChange?.(nextOpen);
    },
    [isControlled, onOpenChange]
  );
  const handleClose = React16.useCallback(() => setOpen(false), [setOpen]);
  React16.useEffect(() => {
    if (!open) return;
    lastActiveRef.current = document.activeElement;
    document.body.classList.add("zek-modal-open");
    dialogRef.current?.focus();
    return () => {
      document.body.classList.remove("zek-modal-open");
      if (lastActiveRef.current?.isConnected) lastActiveRef.current.focus();
    };
  }, [open]);
  React16.useEffect(() => {
    if (!open) return;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        handleClose();
        return;
      }
      if (event.key !== "Tab" || !dialogRef.current) return;
      const focusable = Array.from(dialogRef.current.querySelectorAll(
        'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => {
        const style = window.getComputedStyle(element);
        return !element.hidden && !element.matches('input[type="hidden"]') && element.getAttribute("aria-hidden") !== "true" && style.display !== "none" && style.visibility !== "hidden";
      });
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first || !last) {
        event.preventDefault();
        dialogRef.current.focus();
      } else if (event.shiftKey && (document.activeElement === first || document.activeElement === dialogRef.current)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialogRef.current)) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleClose, open]);
  const triggerNode = trigger ? React16.cloneElement(trigger, {
    onClick: (event) => {
      trigger.props.onClick?.(event);
      if (event.defaultPrevented) return;
      setOpen(!open);
    }
  }) : null;
  return /* @__PURE__ */ jsxs9(Fragment2, { children: [
    triggerNode,
    open && createPortal3(
      /* @__PURE__ */ jsx16(
        "div",
        {
          className: "zek-modal",
          role: "presentation",
          onMouseDown: (event) => {
            if (event.target === event.currentTarget) {
              handleClose();
            }
          },
          children: /* @__PURE__ */ jsxs9(
            "div",
            {
              ref: dialogRef,
              className: clsx9("zek-modal__content", `zek-modal__content--${size}`, className),
              role: "dialog",
              "aria-modal": "true",
              "aria-labelledby": title ? titleId : void 0,
              "aria-describedby": description ? descriptionId : void 0,
              tabIndex: -1,
              children: [
                /* @__PURE__ */ jsx16(
                  "button",
                  {
                    type: "button",
                    className: "zek-modal__close",
                    onClick: handleClose,
                    "aria-label": closeLabel,
                    children: /* @__PURE__ */ jsx16("svg", { viewBox: "0 0 20 20", fill: "none", role: "presentation", children: /* @__PURE__ */ jsx16(
                      "path",
                      {
                        d: "M5 5L15 15M15 5L5 15",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round"
                      }
                    ) })
                  }
                ),
                title && /* @__PURE__ */ jsx16("h3", { className: "zek-modal__title", id: titleId, children: title }),
                description && /* @__PURE__ */ jsx16("p", { className: "zek-modal__description", id: descriptionId, children: description }),
                /* @__PURE__ */ jsx16("div", { className: "zek-modal__body", children })
              ]
            }
          )
        }
      ),
      document.body
    )
  ] });
};

// src/components/PageLayout.tsx
import "react";
import clsx10 from "clsx";
import { jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
var PageLayout = ({
  navigation,
  footerNote,
  footerLinks,
  homeUrl,
  brandName,
  headerVariant = "standard",
  children
}) => {
  return /* @__PURE__ */ jsxs10("div", { className: "zek-body zek-page-shell", children: [
    headerVariant === "landing" ? /* @__PURE__ */ jsx17(LandingNavBar, { tabs: navigation, homeUrl, brandName }) : /* @__PURE__ */ jsx17(Header, { navigation, homeUrl }),
    /* @__PURE__ */ jsx17("main", { className: clsx10("zek-main"), children }),
    /* @__PURE__ */ jsx17(Footer, { copyright: footerNote, links: footerLinks })
  ] });
};

// src/components/RadioGroup.tsx
import "react";
import { jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
var RadioGroup = ({ name, value, onChange, options }) => {
  return /* @__PURE__ */ jsx18("div", { className: "zek-radio-group", children: options.map((option) => /* @__PURE__ */ jsxs11("label", { className: "zek-radio-option", children: [
    /* @__PURE__ */ jsx18(
      "input",
      {
        type: "radio",
        name,
        value: option.value,
        checked: value === option.value,
        onChange: (e) => onChange(e.target.value),
        className: "zek-radio-input"
      }
    ),
    /* @__PURE__ */ jsxs11("div", { children: [
      /* @__PURE__ */ jsx18("div", { className: "zek-radio-label", children: option.label }),
      option.description && /* @__PURE__ */ jsx18("div", { className: "zek-radio-description", children: option.description })
    ] })
  ] }, option.value)) });
};

// src/components/Select.tsx
import React19 from "react";
import clsx11 from "clsx";
import { jsx as jsx19, jsxs as jsxs12 } from "react/jsx-runtime";
var Select = ({ label, helperText, className, children, id, ...props }) => {
  const generatedId = React19.useId();
  const fieldId = id ?? generatedId;
  return /* @__PURE__ */ jsxs12("div", { className: "zek-field", children: [
    label && /* @__PURE__ */ jsx19("label", { className: "zek-label", htmlFor: fieldId, children: label }),
    /* @__PURE__ */ jsx19("select", { id: fieldId, className: clsx11("zek-select", className), ...props, children }),
    helperText && /* @__PURE__ */ jsx19("p", { className: "zek-helper-text", children: helperText })
  ] });
};

// src/components/SidebarNav.tsx
import "react";
import clsx12 from "clsx";
import { jsx as jsx20 } from "react/jsx-runtime";
var SidebarNav = ({ items }) => {
  return /* @__PURE__ */ jsx20("nav", { className: "zek-sidebar-nav", children: items.map((item) => /* @__PURE__ */ jsx20(
    "a",
    {
      href: item.href,
      className: clsx12({ active: item.active }),
      onClick: item.onClick,
      children: item.label
    },
    item.href + item.label
  )) });
};

// src/components/Slider.tsx
import "react";
import clsx13 from "clsx";
import { jsx as jsx21, jsxs as jsxs13 } from "react/jsx-runtime";
var Slider = ({
  label,
  helperText,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  showValue = true,
  valueUnit = "",
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsxs13("div", { className: "zek-field", children: [
    label && /* @__PURE__ */ jsxs13("div", { className: "zek-slider-header", children: [
      /* @__PURE__ */ jsx21("label", { className: "zek-label", children: label }),
      showValue && /* @__PURE__ */ jsxs13("span", { className: "zek-slider-value", children: [
        value,
        valueUnit
      ] })
    ] }),
    /* @__PURE__ */ jsx21(
      "input",
      {
        type: "range",
        min,
        max,
        step,
        value,
        onChange: (e) => onChange(Number(e.target.value)),
        className: clsx13("zek-slider", className),
        ...props
      }
    ),
    helperText && /* @__PURE__ */ jsx21("p", { className: "zek-helper-text", children: helperText })
  ] });
};

// src/components/Tabs.tsx
import "react";
import clsx14 from "clsx";
import { jsx as jsx22 } from "react/jsx-runtime";
var Tabs = ({ tabs, value, onChange }) => {
  return /* @__PURE__ */ jsx22("div", { className: "zek-tabs", children: tabs.map((tab) => /* @__PURE__ */ jsx22(
    "button",
    {
      type: "button",
      className: clsx14("zek-tab", { active: value === tab.id }),
      onClick: () => onChange(tab.id),
      children: tab.label
    },
    tab.id
  )) });
};

// src/components/Tag.tsx
import "react";
import clsx15 from "clsx";
import { jsx as jsx23, jsxs as jsxs14 } from "react/jsx-runtime";
var Tag = ({ children, onRemove, className, ...props }) => {
  return /* @__PURE__ */ jsxs14("span", { className: clsx15("zek-tag", className), ...props, children: [
    children,
    onRemove && /* @__PURE__ */ jsx23("button", { type: "button", className: "text-xs", onClick: onRemove, "aria-label": "Remove", children: "\u2715" })
  ] });
};

// src/components/TextArea.tsx
import React24 from "react";
import clsx16 from "clsx";
import { jsx as jsx24, jsxs as jsxs15 } from "react/jsx-runtime";
var TextArea = ({ label, helperText, className, id, ...props }) => {
  const generatedId = React24.useId();
  const fieldId = id ?? generatedId;
  return /* @__PURE__ */ jsxs15("div", { className: "zek-field", children: [
    label && /* @__PURE__ */ jsx24("label", { className: "zek-label", htmlFor: fieldId, children: label }),
    /* @__PURE__ */ jsx24("textarea", { id: fieldId, className: clsx16("zek-textarea", className), ...props }),
    helperText && /* @__PURE__ */ jsx24("p", { className: "zek-helper-text", children: helperText })
  ] });
};

// src/components/TextField.tsx
import React25 from "react";
import clsx17 from "clsx";
import { jsx as jsx25, jsxs as jsxs16 } from "react/jsx-runtime";
var TextField = ({ label, helperText, className, id, ...props }) => {
  const generatedId = React25.useId();
  const fieldId = id ?? generatedId;
  return /* @__PURE__ */ jsxs16("div", { className: "zek-field", children: [
    label && /* @__PURE__ */ jsx25("label", { className: "zek-label", htmlFor: fieldId, children: label }),
    /* @__PURE__ */ jsx25("input", { id: fieldId, className: clsx17("zek-input", className), ...props }),
    helperText && /* @__PURE__ */ jsx25("p", { className: "zek-helper-text", children: helperText })
  ] });
};

// src/components/Toast.tsx
import React26 from "react";
import clsx18 from "clsx";
import { jsx as jsx26, jsxs as jsxs17 } from "react/jsx-runtime";
var ToastContext = React26.createContext(null);
var useToast = () => {
  const context = React26.useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within <ToastProvider>.");
  }
  return context;
};
var ToastProvider = ({ children }) => {
  const [toasts, setToasts] = React26.useState([]);
  const showToast = React26.useCallback((message, options) => {
    const id = typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID() : `toast-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const toast = {
      id,
      message,
      variant: options?.variant ?? "info",
      duration: options?.duration ?? 3e3
    };
    setToasts((prev) => [...prev, toast]);
  }, []);
  const dismissToast = React26.useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);
  return /* @__PURE__ */ jsxs17(ToastContext.Provider, { value: { showToast }, children: [
    children,
    /* @__PURE__ */ jsx26(ToastViewport, { toasts, onDismiss: dismissToast })
  ] });
};
var ToastViewport = ({ toasts, onDismiss }) => {
  return /* @__PURE__ */ jsx26("div", { className: "zek-toast__container", "aria-live": "polite", "aria-atomic": "true", children: toasts.map((toast) => /* @__PURE__ */ jsx26(ToastCard, { toast, onDismiss }, toast.id)) });
};
var ToastCard = ({
  toast,
  onDismiss
}) => {
  React26.useEffect(() => {
    if (toast.duration <= 0) return void 0;
    const timeout = window.setTimeout(() => onDismiss(toast.id), toast.duration);
    return () => window.clearTimeout(timeout);
  }, [onDismiss, toast.duration, toast.id]);
  return /* @__PURE__ */ jsxs17("div", { className: clsx18("zek-toast", `zek-toast--${toast.variant}`), role: "alert", children: [
    /* @__PURE__ */ jsxs17("span", { className: "zek-toast__icon", "aria-hidden": "true", children: [
      toast.variant === "success" && /* @__PURE__ */ jsx26("svg", { viewBox: "0 0 20 20", fill: "none", role: "presentation", children: /* @__PURE__ */ jsx26(
        "path",
        {
          d: "M16.6667 5L7.5 14.1667L3.33334 10",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ) }),
      toast.variant === "error" && /* @__PURE__ */ jsxs17("svg", { viewBox: "0 0 20 20", fill: "none", role: "presentation", children: [
        /* @__PURE__ */ jsx26("circle", { cx: "10", cy: "10", r: "7.5", stroke: "currentColor", strokeWidth: "2" }),
        /* @__PURE__ */ jsx26(
          "path",
          {
            d: "M10 6V10M10 13.5V14",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        )
      ] }),
      toast.variant === "warning" && /* @__PURE__ */ jsxs17("svg", { viewBox: "0 0 20 20", fill: "none", role: "presentation", children: [
        /* @__PURE__ */ jsx26(
          "path",
          {
            d: "M10 3.33334L17.5 16.6667H2.5L10 3.33334Z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx26(
          "path",
          {
            d: "M10 8.33334V11.6667M10 13.3333V14",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        )
      ] }),
      toast.variant === "info" && /* @__PURE__ */ jsxs17("svg", { viewBox: "0 0 20 20", fill: "none", role: "presentation", children: [
        /* @__PURE__ */ jsx26("circle", { cx: "10", cy: "10", r: "7.5", stroke: "currentColor", strokeWidth: "2" }),
        /* @__PURE__ */ jsx26(
          "path",
          {
            d: "M10 10V14M10 7V7.5",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx26("span", { className: "zek-toast__message", children: toast.message }),
    /* @__PURE__ */ jsx26(
      "button",
      {
        type: "button",
        className: "zek-toast__close",
        onClick: () => onDismiss(toast.id),
        "aria-label": "Dismiss",
        children: /* @__PURE__ */ jsx26("svg", { viewBox: "0 0 16 16", fill: "none", role: "presentation", children: /* @__PURE__ */ jsx26(
          "path",
          {
            d: "M12 4L4 12M4 4L12 12",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ) })
      }
    )
  ] });
};

// src/components/Toggle.tsx
import "react";
import clsx19 from "clsx";
import { jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var Toggle = ({ checked, onChange, label }) => {
  return /* @__PURE__ */ jsxs18("label", { className: "zek-toggle", children: [
    /* @__PURE__ */ jsx27("span", { className: "zek-label zek-toggle-label", children: label }),
    /* @__PURE__ */ jsx27(
      "button",
      {
        type: "button",
        "aria-pressed": checked,
        onClick: () => onChange(!checked),
        className: clsx19("zek-toggle-button", { "justify-start": !checked }),
        "data-state": checked ? "on" : "off",
        children: /* @__PURE__ */ jsx27("span", { className: "zek-toggle-thumb" })
      }
    )
  ] });
};

// src/theme/breakpoints.ts
var breakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
};

// src/theme/colors.ts
var lightColors = {
  primary: "#fc8c06",
  primaryStrong: "#b06204",
  surface: "#111111",
  surfaceAlt: "#232323",
  border: "#3F3F3F",
  text: "#ffffff",
  muted: "#9ca3af",
  canvas: "#040D21",
  headerBackdrop: "rgba(4, 8, 14, 0.09)"
};
var darkColors = {
  primary: "#f3ac41",
  primaryStrong: "#f08a00",
  surface: "#0b0b0f",
  surfaceAlt: "#181820",
  border: "#2a2a33",
  text: "#f7f7fb",
  muted: "#b3b6c2",
  canvas: "#05070d",
  headerBackdrop: "rgba(5, 7, 13, 0.4)"
};

// src/theme/radii.ts
var radii = {
  sm: "8px",
  md: "12px",
  lg: "15px",
  pill: "999px"
};

// src/theme/shadows.ts
var shadows = {
  soft: "0 6px 18px rgba(0, 0, 0, 0.25)",
  strong: "0 10px 40px rgba(0, 0, 0, 0.3)"
};

// src/theme/spacing.ts
var spacing = {
  none: "0",
  xs: "0.25rem",
  sm: "0.5rem",
  md: "0.75rem",
  lg: "1rem",
  xl: "1.5rem",
  xxl: "2rem",
  xxxl: "3rem"
};

// src/theme/typography.ts
var typography = {
  fontFamily: "'Cabin', 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  monoFamily: "'Fira Code', ui-monospace, SFMono-Regular, Menlo, monospace",
  brandFamily: "'Fira Code', monospace",
  weights: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  sizes: {
    xs: "0.8rem",
    sm: "0.9rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.35rem",
    display: "2.25rem"
  }
};

// src/theme/tokens.ts
var theme = {
  colors: lightColors,
  spacing,
  radii,
  shadows,
  breakpoints,
  typography
};
var darkTheme = {
  ...theme,
  colors: darkColors,
  shadows: {
    soft: "0 6px 18px rgba(0, 0, 0, 0.35)",
    strong: "0 10px 40px rgba(0, 0, 0, 0.5)"
  }
};
var themeToCSSVariables = (tokens) => ({
  "--zek-font-sans": tokens.typography.fontFamily,
  "--zek-font-mono": tokens.typography.monoFamily,
  "--zek-font-brand": tokens.typography.brandFamily,
  "--zek-color-surface": tokens.colors.surface,
  "--zek-color-surface-alt": tokens.colors.surfaceAlt,
  "--zek-color-border": tokens.colors.border,
  "--zek-color-primary": tokens.colors.primary,
  "--zek-color-primary-strong": tokens.colors.primaryStrong,
  "--zek-color-text": tokens.colors.text,
  "--zek-color-muted": tokens.colors.muted,
  "--zek-color-black": tokens.colors.canvas,
  "--zek-header-backdrop": tokens.colors.headerBackdrop,
  "--zek-radius": tokens.radii.lg,
  "--zek-radius-sm": tokens.radii.sm,
  "--zek-radius-pill": tokens.radii.pill,
  "--zek-shadow": tokens.shadows.strong,
  "--zek-spacing-xs": tokens.spacing.xs,
  "--zek-spacing-sm": tokens.spacing.sm,
  "--zek-spacing-md": tokens.spacing.md,
  "--zek-spacing-lg": tokens.spacing.lg,
  "--zek-spacing-xl": tokens.spacing.xl,
  "--zek-spacing-xxl": tokens.spacing.xxl,
  "--zek-spacing-xxxl": tokens.spacing.xxxl,
  "--zek-font-size-xs": tokens.typography.sizes.xs,
  "--zek-font-size-sm": tokens.typography.sizes.sm,
  "--zek-font-size-md": tokens.typography.sizes.md,
  "--zek-font-size-lg": tokens.typography.sizes.lg,
  "--zek-font-size-xl": tokens.typography.sizes.xl,
  "--zek-font-size-display": tokens.typography.sizes.display,
  "--zek-breakpoint-sm": tokens.breakpoints.sm,
  "--zek-breakpoint-md": tokens.breakpoints.md,
  "--zek-breakpoint-lg": tokens.breakpoints.lg,
  "--zek-breakpoint-xl": tokens.breakpoints.xl
});

// src/theme/ThemeProvider.tsx
import { createContext, useContext, useMemo } from "react";
import clsx20 from "clsx";
import { jsx as jsx28 } from "react/jsx-runtime";
var ThemeContext = createContext(theme);
var useTheme = () => useContext(ThemeContext);
var ThemeProvider = ({
  theme: theme2 = theme,
  as: Component = "div",
  className,
  style,
  children,
  ...rest
}) => {
  const cssVariables = useMemo(() => themeToCSSVariables(theme2), [theme2]);
  return /* @__PURE__ */ jsx28(ThemeContext.Provider, { value: theme2, children: /* @__PURE__ */ jsx28(Component, { className: clsx20("zek-body", className), style: { ...cssVariables, ...style }, ...rest, children }) });
};
export {
  BackButton,
  Badge,
  Button,
  Card,
  Checkbox,
  ColorPicker,
  Dropdown,
  FileUpload,
  Footer,
  Header,
  Icon,
  IconButton,
  LandingNavBar,
  MarkdownPreview,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Modal,
  PageLayout,
  RadioGroup,
  Select,
  SidebarNav,
  Slider,
  Tabs,
  Tag,
  TextArea,
  TextField,
  ThemeProvider,
  ToastProvider,
  Toggle,
  darkTheme,
  theme,
  themeToCSSVariables,
  useTheme,
  useToast
};
//# sourceMappingURL=index.js.map